<div class="toolbar">
  <p-button
    label="Nuevo perfil"
    icon="pi pi-plus"
    (click)="newProfile()"
  ></p-button>
  <p-button
    label="Eliminar seleccionados"
    severity="danger"
    (click)="deleteSelected()"
    *ngIf="selectedRecords?.length"
  ></p-button>
</div>

<p-table
  [value]="records$ | async"
  styleClass="p-datatable-striped"
  sortMode="single"
  [(selection)]="selectedRecords"
  dataKey="id"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem" id="checkbox-column"></th>

      <th pSortableColumn="key" id="key-column">
        Código <p-sortIcon field="key"></p-sortIcon>
      </th>
      <th pSortableColumn="title" id="title-column">
        Título <p-sortIcon field="title"></p-sortIcon>
      </th>
      <th pSortableColumn="createdAt" id="createdAt-column">
        Creado <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
      <th id="isDefault-column">Por defecto</th>
      <th id="application-column">Aplicación</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr>
      <td>
        <div class="row-buttons">
          <p-tableCheckbox [value]="record"></p-tableCheckbox>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="onRowEdit(record)"
            class="p-button-rounded p-button-text"
          ></button>
        </div>
      </td>
      <td>{{ record.key }}</td>
      <td>{{ record.title }}</td>
      <td>{{ record.createdAt | date : "dd MMM yyyy, HH:mm" }}</td>
      <td>{{ record.isDefault ? "Por defecto" : "" }}</td>
      <td>{{ record.application?.description || "--" }}</td>
    </tr>
  </ng-template>
</p-table>
